(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews-w"] && !Shopify.designMode) return;
  try {
    
(function () {
    var SELECTOR = '[data-rw-carousel]';

    function pad(track) {
        return parseFloat(getComputedStyle(track).paddingLeft) || 0;
    }

    function setup(el) {
        if (el.__rwInit) return;
        el.__rwInit = true;

        var track = el.querySelector('[data-rw-track]');
        if (!track) return;
        var controls = el.querySelector('[data-rw-controls]');
        var prev = el.querySelector('[data-rw-prev]');
        var next = el.querySelector('[data-rw-next]');
        var dotsWrap = el.querySelector('[data-rw-dots]');
        var cards = Array.prototype.slice.call(track.children);
        if (!cards.length) return;

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var behavior = reduce ? 'auto' : 'smooth';

        function overflowing() {
            return track.scrollWidth - track.clientWidth > 2;
        }

        function goTo(card) {
            var delta = card.getBoundingClientRect().left - track.getBoundingClientRect().left - pad(track);
            track.scrollBy({ left: delta, behavior: behavior });
        }

        function step(dir) {
            track.scrollBy({ left: track.clientWidth * dir, behavior: behavior });
        }

        function activeIndex() {
            var ref = track.getBoundingClientRect().left + pad(track);
            var idx = 0, best = Infinity;
            cards.forEach(function (card, i) {
                var d = Math.abs(card.getBoundingClientRect().left - ref);
                if (d < best) { best = d; idx = i; }
            });
            return idx;
        }

        function buildDots() {
            if (!dotsWrap) return;
            dotsWrap.innerHTML = '';
            if (!overflowing()) return;
            cards.forEach(function (card, i) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'sf-reviews-w__dot';
                b.setAttribute('aria-label', 'Go to review ' + (i + 1));
                b.addEventListener('click', function () { goTo(card); });
                dotsWrap.appendChild(b);
            });
        }

        function dots() {
            return dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
        }

        function update() {
            var can = overflowing();
            if (controls) controls.hidden = !can;
            if (!can) return;
            var sl = track.scrollLeft;
            var max = track.scrollWidth - track.clientWidth;
            if (prev) prev.disabled = sl <= 1;
            if (next) next.disabled = sl >= max - 1;
            var idx = activeIndex();
            dots().forEach(function (dot, i) {
                if (i === idx) dot.setAttribute('aria-current', 'true');
                else dot.removeAttribute('aria-current');
            });
        }

        function rebuild() {
            buildDots();
            update();
        }

        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });

        var ticking = false;
        track.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () { update(); ticking = false; });
        }, { passive: true });

        rebuild();

        if ('ResizeObserver' in window) {
            var ro = new ResizeObserver(function () { rebuild(); });
            ro.observe(track);
        } else {
            window.addEventListener('resize', rebuild);
        }

        Array.prototype.slice.call(el.querySelectorAll('img')).forEach(function (img) {
            if (!img.complete) {
                img.addEventListener('load', rebuild, { once: true });
                img.addEventListener('error', rebuild, { once: true });
            }
        });

        if (el.getAttribute('data-rw-autoplay') === 'true' && !reduce) {
            var speed = (parseInt(el.getAttribute('data-rw-autoplay-speed'), 10) || 5) * 1000;
            var timer = null;
            function play() {
                stop();
                timer = window.setInterval(function () {
                    if (!overflowing()) return;
                    var sl = track.scrollLeft, max = track.scrollWidth - track.clientWidth;
                    if (sl >= max - 1) track.scrollTo({ left: 0, behavior: behavior });
                    else step(1);
                }, speed);
            }
            function stop() {
                if (timer) { window.clearInterval(timer); timer = null; }
            }
            el.addEventListener('mouseenter', stop);
            el.addEventListener('mouseleave', play);
            el.addEventListener('focusin', stop);
            el.addEventListener('focusout', play);
            document.addEventListener('visibilitychange', function () {
                if (document.hidden) stop(); else play();
            });
            play();
        }
    }

    function init(root) {
        var scope = root && root.querySelectorAll ? root : document;
        var nodes = scope.querySelectorAll(SELECTOR);
        Array.prototype.slice.call(nodes).forEach(setup);
        if (root && root.matches && root.matches(SELECTOR)) setup(root);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-w"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_BP = 767;

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function initSection(root) {
      if (!root || root.__lfwInit) return;

      var viewport = root.querySelector('.sf-lfw__viewport');
      var track = root.querySelector('.sf-lfw__track');
      if (!viewport || !track || !track.children.length) return;

      root.__lfwInit = true;

      var reduceMotion = false;
      try {
        reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      var originals = Array.prototype.slice.call(track.children);
      var dir = root.getAttribute('data-lfw-direction') === 'rtl' ? 1 : -1;
      var mode = root.getAttribute('data-lfw-motion') === 'glide' ? 'glide' : 'step';

      var stepDur = parseFloat(root.getAttribute('data-lfw-step-duration'));
      if (isNaN(stepDur)) stepDur = 600;
      var dwellMs = parseFloat(root.getAttribute('data-lfw-step-pause'));
      if (isNaN(dwellMs)) dwellMs = 2000;

      var offset = 0;
      var setWidth = 0;
      var rafId = null;
      var lastTs = 0;
      var visible = false;
      var hovering = false;
      var dragging = false;
      var editorPaused = false;
      var moved = 0;
      var videoObserver = null;
      var sectionObserver = null;
      var resizeTimer = null;
      var destroyed = false;

      // step-animation state
      var animating = false;
      var animFrom = 0;
      var animTo = 0;
      var animDur = stepDur;
      var animStart = -1;
      var stepTimer = null;

      function isMobile() {
        return window.innerWidth <= MOBILE_BP;
      }

      function autoAllowed() {
        if (destroyed) return false;
        if (reduceMotion || dragging || editorPaused) return false;
        if (!visible || document.hidden) return false;
        if (root.getAttribute('data-lfw-autoplay') !== 'true') return false;
        if (isMobile() && root.getAttribute('data-lfw-autoplay-mobile') !== 'true') return false;
        if (hovering && root.getAttribute('data-lfw-pause-hover') === 'true') return false;
        return true;
      }

      function glideSpeed() {
        if (!autoAllowed()) return 0;
        var s = parseFloat(root.getAttribute('data-lfw-speed'));
        return isNaN(s) ? 40 : s;
      }

      function gapSize() {
        var cs = window.getComputedStyle(track);
        return parseFloat(cs.columnGap || cs.gap) || 0;
      }

      function clearClones() {
        var clones = track.querySelectorAll('[data-lfw-clone]');
        for (var i = clones.length - 1; i >= 0; i--) {
          clones[i].parentNode.removeChild(clones[i]);
        }
      }

      // Duplicate the card set until the track is at least one full set wider than
      // the viewport, so wrapping the offset by setWidth is visually undetectable.
      function buildClones() {
        clearClones();
        if (!originals.length) return;

        var first = originals[0];
        var last = originals[originals.length - 1];
        setWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft + gapSize();
        if (!setWidth || setWidth < 1) return;

        var needed = setWidth + viewport.clientWidth * 2;
        var total = setWidth;
        var guard = 0;

        while (total < needed && guard < 30) {
          var frag = document.createDocumentFragment();
          for (var i = 0; i < originals.length; i++) {
            var clone = originals[i].cloneNode(true);
            clone.setAttribute('data-lfw-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            clone.removeAttribute('id');
            var links = clone.querySelectorAll('a, button');
            for (var j = 0; j < links.length; j++) links[j].setAttribute('tabindex', '-1');
            frag.appendChild(clone);
          }
          track.appendChild(frag);
          total += setWidth;
          guard++;
        }

        observeVideos();
      }

      function playVideo(v) {
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      // Only decode the handful of videos actually on screen.
      function observeVideos() {
        var videos = track.querySelectorAll('video');
        if (!('IntersectionObserver' in window)) {
          for (var k = 0; k < videos.length; k++) playVideo(videos[k]);
          return;
        }

        if (videoObserver) videoObserver.disconnect();
        videoObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                playVideo(entry.target);
              } else {
                entry.target.pause();
              }
            });
          },
          { root: viewport, rootMargin: '200px 0px', threshold: 0.01 }
        );

        for (var i = 0; i < videos.length; i++) {
          var v = videos[i];
          v.muted = true;
          v.playsInline = true;
          v.setAttribute('playsinline', '');
          videoObserver.observe(v);
        }
      }

      // `offset` is never wrapped mid-animation (that would corrupt animFrom/animTo);
      // only the value written to the transform is wrapped. normalize() folds the
      // real offset back into range at rest.
      function apply() {
        if (destroyed) return;
        var d = offset;
        if (setWidth > 0) d = ((d % setWidth) + setWidth) % setWidth;
        track.style.transform = 'translate3d(' + -d + 'px, 0, 0)';
      }

      function normalize() {
        if (setWidth > 0) offset = ((offset % setWidth) + setWidth) % setWidth;
      }

      function startRaf() {
        if (destroyed || rafId !== null || document.hidden) return;
        rafId = window.requestAnimationFrame(frame);
      }

      function clearStepTimer() {
        if (stepTimer) {
          clearTimeout(stepTimer);
          stepTimer = null;
        }
      }

      // Wait `delay` ms, then advance exactly one card.
      function queueStep(delay) {
        clearStepTimer();
        if (mode !== 'step' || !autoAllowed()) return;
        stepTimer = setTimeout(function () {
          stepTimer = null;
          if (autoAllowed()) startStep(dir);
        }, Math.max(0, delay));
      }

      function animateTo(target, duration) {
        animFrom = offset;
        animTo = target;
        animDur = duration > 0 ? duration : 1;
        animStart = -1;
        animating = true;
        clearStepTimer();
        startRaf();
      }

      function startStep(sign) {
        var s = cardStep();
        if (!s) return;
        animateTo(offset + sign * s, stepDur);
      }

      function frame(ts) {
        rafId = null;

        if (dragging) {
          apply();
          startRaf();
          return;
        }

        if (animating) {
          if (animStart < 0) animStart = ts;
          var t = (ts - animStart) / animDur;
          if (t >= 1) {
            offset = animTo;
            animating = false;
            normalize();
            apply();
            if (mode === 'step') {
              queueStep(dwellMs);
            } else {
              lastTs = 0;
              startRaf();
            }
            return;
          }
          offset = animFrom + (animTo - animFrom) * easeInOutCubic(t);
          apply();
          startRaf();
          return;
        }

        if (mode === 'glide') {
          var sp = glideSpeed();
          if (sp === 0) {
            lastTs = 0;
            apply();
            return;
          }
          if (!lastTs) lastTs = ts;
          var dt = Math.min(ts - lastTs, 50);
          lastTs = ts;
          offset += dir * sp * dt / 1000;
          normalize();
          apply();
          startRaf();
          return;
        }

        // step mode at rest: the dwell timer drives the next move, not rAF.
      }

      // Re-evaluate after anything that could change whether motion is allowed.
      function wake() {
        if (mode === 'step') {
          if (!autoAllowed()) {
            clearStepTimer();
            return;
          }
          if (!animating && !stepTimer) queueStep(dwellMs);
        } else {
          lastTs = 0;
          startRaf();
        }
      }

      function cardStep() {
        var card = track.querySelector('.sf-lfw__card');
        return card ? card.offsetWidth + gapSize() : viewport.clientWidth * 0.6;
      }

      var prevBtn = root.querySelector('.sf-lfw__arrow--prev');
      var nextBtn = root.querySelector('.sf-lfw__arrow--next');
      function onPrev() { startStep(-1); }
      function onNext() { startStep(1); }
      if (prevBtn) prevBtn.addEventListener('click', onPrev);
      if (nextBtn) nextBtn.addEventListener('click', onNext);

      /* ----- drag / swipe ----- */

      var lastX = 0;
      var velocity = 0;
      var lastMoveTs = 0;

      function onPointerDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest && e.target.closest('.sf-lfw__arrow')) return;
        dragging = true;
        moved = 0;
        animating = false;
        clearStepTimer();
        velocity = 0;
        lastX = e.clientX;
        lastMoveTs = (window.performance && performance.now()) || 0;
        viewport.classList.add('is-dragging');
        try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      }

      function onPointerMove(e) {
        if (!dragging) return;
        var dx = e.clientX - lastX;
        lastX = e.clientX;
        moved += Math.abs(dx);
        var now = (window.performance && performance.now()) || 0;
        var dt = now - lastMoveTs || 16;
        lastMoveTs = now;
        velocity = dx / dt;
        offset -= dx;
        apply();
      }

      function onPointerUp(e) {
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        try { viewport.releasePointerCapture(e.pointerId); } catch (err) {}
        normalize();

        if (mode === 'step') {
          // Land back on a card boundary so the rhythm stays aligned; a decisive
          // flick carries one extra card in the direction of travel.
          var s = cardStep();
          if (s) {
            var target = Math.round(offset / s) * s;
            if (Math.abs(velocity) > 0.3) target += (velocity < 0 ? 1 : -1) * s;
            animateTo(target, stepDur);
            return;
          }
        }

        wake();
      }

      function onDragStart(e) { e.preventDefault(); }

      // A swipe must never navigate to the product.
      function onTrackClick(e) {
        if (moved > 8) {
          e.preventDefault();
          e.stopPropagation();
        }
      }

      function onEnter() { hovering = true; wake(); }
      function onLeave() { hovering = false; wake(); }

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove);
      viewport.addEventListener('pointerup', onPointerUp);
      viewport.addEventListener('pointercancel', onPointerUp);
      viewport.addEventListener('dragstart', onDragStart);
      track.addEventListener('click', onTrackClick, true);

      /* ----- lifecycle ----- */

      root.addEventListener('mouseenter', onEnter);
      root.addEventListener('mouseleave', onLeave);

      function onResize() {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          // card width changes at the breakpoint, so an in-flight step would land
          // on a stale target — drop it and snap to the nearest boundary.
          animating = false;
          clearStepTimer();
          buildClones();
          var s = cardStep();
          if (mode === 'step' && s) offset = Math.round(offset / s) * s;
          normalize();
          apply();
          wake();
        }, 150);
      }

      function onVisibility() { wake(); }

      function onLoad() {
        if (destroyed) return;
        buildClones();
        apply();
        wake();
      }

      window.addEventListener('resize', onResize);
      window.addEventListener('orientationchange', onResize);
      document.addEventListener('visibilitychange', onVisibility);

      if ('IntersectionObserver' in window) {
        sectionObserver = new IntersectionObserver(
          function (entries) {
            visible = entries[0].isIntersecting;
            wake();
          },
          { rootMargin: '150px 0px' }
        );
        sectionObserver.observe(root);
      } else {
        visible = true;
      }

      buildClones();
      apply();
      wake();

      // Widths are CSS-var driven so layout is stable immediately, but re-measure
      // once fonts/images have settled just in case.
      window.addEventListener('load', onLoad);

      root.__lfwFocusBlock = function (blockEl) {
        editorPaused = true;
        animating = false;
        clearStepTimer();
        offset = blockEl.offsetLeft - 40;
        normalize();
        apply();
      };

      root.__lfwResume = function () {
        editorPaused = false;
        wake();
      };

      // Must tear down completely: in the preview harness (and any re-init against
      // the same DOM) a surviving listener would wake the old closure and fight the
      // new one for the transform, using the old direction/mode.
      root.__lfwDestroy = function () {
        destroyed = true;
        if (rafId !== null) window.cancelAnimationFrame(rafId);
        rafId = null;
        clearStepTimer();
        animating = false;
        if (videoObserver) videoObserver.disconnect();
        if (sectionObserver) sectionObserver.disconnect();
        if (resizeTimer) clearTimeout(resizeTimer);

        window.removeEventListener('resize', onResize);
        window.removeEventListener('orientationchange', onResize);
        window.removeEventListener('load', onLoad);
        document.removeEventListener('visibilitychange', onVisibility);

        viewport.removeEventListener('pointerdown', onPointerDown);
        viewport.removeEventListener('pointermove', onPointerMove);
        viewport.removeEventListener('pointerup', onPointerUp);
        viewport.removeEventListener('pointercancel', onPointerUp);
        viewport.removeEventListener('dragstart', onDragStart);
        track.removeEventListener('click', onTrackClick, true);
        root.removeEventListener('mouseenter', onEnter);
        root.removeEventListener('mouseleave', onLeave);
        if (prevBtn) prevBtn.removeEventListener('click', onPrev);
        if (nextBtn) nextBtn.removeEventListener('click', onNext);

        root.__lfwInit = false;
      };
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('.sf-lfw');
      for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var nodes = e.target.querySelectorAll ? e.target.querySelectorAll('.sf-lfw') : [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].__lfwDestroy) nodes[i].__lfwDestroy();
      }
    });

    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest ? e.target.closest('.sf-lfw') : null;
      if (root && root.__lfwFocusBlock) root.__lfwFocusBlock(e.target);
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest ? e.target.closest('.sf-lfw') : null;
      if (root && root.__lfwResume) root.__lfwResume();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marq-w"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.marq-w-section');
    sections.forEach(function (section) {
      var root = section;
      var content = root.querySelector('.marq-w-content');
      if (!content) return;

      var elementsDisplayed = getComputedStyle(root).getPropertyValue('--marq-w-elements-displayed').trim();
      var isMobile = window.innerWidth <= 749;
      if (isMobile) {
        elementsDisplayed = getComputedStyle(root).getPropertyValue('--marq-w-elements-displayed-mobile').trim();
      }

      var totalElements = getComputedStyle(root).getPropertyValue('--marq-w-elements').trim();
      var speed = getComputedStyle(root).getPropertyValue('--marq-w-speed').trim();
      var speedNum = parseFloat(speed);

      var elementWidth = 100 / parseFloat(elementsDisplayed);
      root.style.setProperty('--marq-w-element-width', elementWidth + 'vw');
      root.style.setProperty('--marq-w-animation-duration', (parseFloat(totalElements) * speedNum) + 's');

      var originalCount = content.children.length;
      for (var i = 0; i < Math.ceil(parseFloat(elementsDisplayed)); i++) {
        if (content.children[i]) {
          content.appendChild(content.children[i].cloneNode(true));
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
